import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TState = {
  history: string[];
  redirects: string[];
};

export const initialState: TState = {
  history: [],
  redirects: []
};

export const slice = createSlice({
  name: 'journeyRoutes',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.history = initialState.history;
      state.redirects = initialState.redirects;
    },
    pushHistory: (state, { payload }: PayloadAction<string>) => {
      const lastPath = state.history[state.history.length - 1];
      const history =
        lastPath !== payload
          ? [...state.history, payload].filter(
              (p) => !state.redirects.includes(p)
            )
          : state.history;

      state.history = history;
    },
    replaceHistory: (state, { payload }: PayloadAction<string>) => {
      state.history[state.history.length - 1] = payload;
    },
    popHistory: (state, { payload }: PayloadAction<string>) => {
      const { history } = state;
      const pathIndex = history.indexOf(payload);

      return {
        ...state,
        history: [...history.slice(0, pathIndex + 1)]
      };
    },
    redirectPath: (state, { payload }: PayloadAction<string>) => {
      return {
        ...state,
        redirects: [...state.redirects, payload]
      };
    }
  }
});

export const {
  setInitialState,
  pushHistory,
  replaceHistory,
  popHistory,
  redirectPath
} = slice.actions;

export const selectSlice = (state: { [key: string]: TState }) =>
  state[slice.name];
export const selectHistory = (state: { [key: string]: TState }) =>
  selectSlice(state).history;
export const selectRedirects = (state: { [key: string]: TState }) =>
  selectSlice(state).redirects;
export const selectPreviousPath = (state: { [key: string]: TState }) => {
  const history = selectHistory(state);
  const currentPath = history[history.length - 1];
  const hash = currentPath?.match(/#.*$/)?.[0];
  const noHashCurrentPath = currentPath?.replace(hash ?? '', '');
  const noHashCurrentPathIndex = history.indexOf(noHashCurrentPath);
  return history[noHashCurrentPathIndex - 1] || history[0];
};

export default slice.reducer;
